import React from 'react';
import ReactSelect, { createFilter, components } from 'react-select';
import Highlighter from 'react-highlight-words';
import {Mixin as FormsyMixin} from 'formsy-react';
import ComponentMixin from 'formsy-react-components/release/mixins/component';
import {Row} from 'formsy-react-components';
import * as Instanced from '../../standalone/instanceHelper';
import SafeHTML from '../fw/SafeHTML.react';

import './SearchableSelect.scss';

// eslint-disable-next-line
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/prop-types */
let SelectBox = React.createClass({
	displayName: 'Select',

	mixins: [FormsyMixin, ComponentMixin],

	getInitialState () {
		return {
			isInstanced: Instanced.isInstanced(),
			loadingInstancedFunc: false,
			loading: Instanced.isInstanced(),
		};
	},

	changeValue: function changeValue(item) {
		if (this.props.multiple) {
			let list = item.map((a) => a.value);
			this.setValue(list);
			this.props.onChange(this.props.name, list);
		} else {
			if (item && item.value !== undefined) {
				this.setValue(item.value);
				this.props.onChange(this.props.name, item.value);
			}
			else {
				throw new Error('Unsuspect selected item: ' + JSON.stringify(item) + ', All options: ' + JSON.stringify(this.props.options));
			}
		}
	},

	inputValue: function inputValue(item) {
		this.setState({inputValue: item || ''});
	},

    render: function render() {
		if (this.state.isInstanced && this.state.loading) {
			if (!this.state.loadingInstancedFunc) {
				setTimeout(() => {
					if (this.__isMounted) {
						this.setState({
							loadingInstancedFunc: true
						});
					}
				});

				Instanced.getInstanceHelper().then((funcs) => {
					this.instanceFuncs = funcs;

					if (this.__isMounted) {
						this.setState({
							loadingInstancedFunc: false,
							loading: false
						});
					}
				}).catch(() => {});
			}

			return null;
		}

        if (this.getLayout() === 'elementOnly') {
            return this.renderElement();
        }

        return React.createElement(
            Row,
            _extends({}, this.getRowProperties(), {
                htmlFor: this.getId()
            }),
            this.renderElement(),
            this.renderHelp(),
            this.renderErrorMessage()
        );
    },

	/**
	 * @override Select.renderElement
	 */
	renderElement: function renderElement() {
		let passProps = JSON.parse(JSON.stringify(this.props));
		let htmlHelp = null;
		let help = null;

		if (passProps.htmlHelp) {
			htmlHelp = <span className="help-block"><SafeHTML value={passProps.htmlHelp + '<br/>'} /></span>;
		} else if (passProps.help) {
			//help = <span className="help-block">{passProps.help}</span>;
		}

		delete passProps.id;
		delete passProps.value;
		delete passProps.onChange;
		delete passProps.disabled;
		delete passProps.htmlHelp;
		delete passProps.help;

		let self = this;

		if (this.state.isInstanced && this.instanceFuncs && this.instanceFuncs.SearchableSelectRenderElement) {
			return this.instanceFuncs.SearchableSelectRenderElement.call(this, passProps);
		}

		const filterConfig = {
			ignoreCase: true,
			ignoreAccents: true,
			trim: true,
			matchFrom: 'any',
		};

		let currentValue = this.getValue();
		if (this.props.multiple) {
			currentValue = (this.getValue() || []).map((val) => this.props.options.find((a) => a.value === val || a.value === "true" && val === true || a.value === "false" && val === false));
		} else {
			currentValue = this.props.options.find((a) => a.value === currentValue || a.value === "true" && currentValue === true || a.value === "false" && currentValue === false);
		}

		return (<div><ReactSelect
			className="searchable-select"
			components={{ Option: (props) => {
				if (this.state.inputValue && this.state.inputValue !== '') {
					return (
						<components.Option {...props}>
							<Highlighter searchWords={[this.state.inputValue]} textToHighlight={props.data.label} />
						</components.Option>
					);
				}

				return <components.Option {...props} />;
			}}}
			filterOption={createFilter(filterConfig)}
			id={this.getId()}
			inputValue={this.state.inputValue}
			isClearable={false}
			isDisabled={this.isFormDisabled() || this.props.disabled}
			isMulti={this.props.multiple}
			isSearchable
			onChange={this.changeValue}
			onInputChange={this.inputValue}
			options={this.props.options}
			ref={el => {self.element = el;}}
			styles={{
				menu: (provided, state) => ({
					...provided,
					'z-index': 100,
				}),
			}}
			value={currentValue}
			{...passProps}
		/>{help}{htmlHelp}</div>);
    }
});

export default SelectBox;
